<mat-expansion-panel
  [expanded]="isExpanded()"
  [hideToggle]="isExpanded()"
  [ngClass]="getBannerClass(type())"
  *appIfFeatureEnabled="Feature.InfoAlertNBTH"
  class="mat-expansion-panel"
>
  <mat-expansion-panel-header>
    <div class="mat-expansion-panel__header">
      <app-spark-icon [icon]="type()" size="24"></app-spark-icon>
      <mat-panel-title>
        @if (header()) {
        <header>
          <span>{{ header() }}</span>
        </header>
        }
      </mat-panel-title>
    </div>
  </mat-expansion-panel-header>
  <div class="mat-expansion-panel__body">
    <ng-content></ng-content>
    @if (buttonName()) {
    <footer>
      <app-button
        matSnackBarAction
        (buttonClick)="handleButtonClick()"
        [isDisabled]="isDisabled()"
        [size]="'small'"
        type="primary"
      >
        {{ buttonName() }}
      </app-button>
    </footer>
    }
  </div>
</mat-expansion-panel>
